import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Grid, Stack } from "@mui/material";
import { FC, useCallback } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { JobFormTitle } from "@/features/job/components/job-form/JobFormTitle";
import { TJobForm, TJobObject } from "@/features/job/types/JobForm";
import { Textarea } from "@/components/elements/Textarea";
import { JobObjectFields } from "@/features/job/components/job-form/JobObjectFields";
import { DEFAULT_ONBOARDING_SUPPORTS, DEFAULT_SELF_EXPENSES } from "@/features/job/constants/defaults";

type TJobFeatureProps = {
  isDraft?: boolean;
  onboardingSupportRef: React.MutableRefObject<HTMLDivElement | null>;
  selfExpenseRef: React.MutableRefObject<HTMLDivElement | null>;
};

export const JobFeature: FC<TJobFeatureProps> = ({ selfExpenseRef, onboardingSupportRef }) => {
  const methods = useFormContext<TJobForm>();
  const { control, setValue } = methods;

  const selfExpenseWatchField = useWatch({
    control,
    name: "selfExpense",
  });

  const onboardingSupportWatchField = useWatch({
    control,
    name: "onboardingSupport",
  });

  const handleSelfExpenseChange = useCallback((val: TJobObject[]) => {
    setValue("selfExpense", val);
  }, []);

  const handleOnboardingSupportChange = useCallback((val: TJobObject[]) => {
    setValue("onboardingSupport", val);
  }, []);

  return (
    <Stack gap={2}>
      <InnerBox title={<JobFormTitle text="求人特徴" />} showDivider={false}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <JobObjectFields
              title="本人負担費用"
              textButton="本人負担費用を追加"
              fieldRef={selfExpenseRef}
              selected={selfExpenseWatchField}
              defaultObject={DEFAULT_SELF_EXPENSES}
              onChange={handleSelfExpenseChange}
            />
          </Grid>
          <Grid item xs={12}>
            <FormField control={control} name="companyFeatures">
              <Textarea />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="foreignEmployees">
              <Textarea />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <JobObjectFields
              title="受け入れ体制・サポート"
              textButton="受け入れ体制・サポートを追加"
              fieldRef={onboardingSupportRef}
              selected={onboardingSupportWatchField}
              defaultObject={DEFAULT_ONBOARDING_SUPPORTS}
              onChange={handleOnboardingSupportChange}
            />
          </Grid>
        </Grid>
      </InnerBox>
    </Stack>
  );
};
